import { createUseStyles } from 'react-jss'

export default createUseStyles({
  button: {
    margin: 10
  },
  card: {
    borderBottomLeftRadius: '0 !important',
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardBody: {
    backgroundColor: 'var(--primary__page__background) !important'
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    height: '860px',
    justifyContent: 'center'
  }
})
